import React, { useEffect, useRef, useState } from 'react';
import {
  Wrapper,
  HeaderWrapper,
  Span1,
  Span2,
  QueryPara,
  ChannelsText,
  TwitterText,
  StyledContainer,
  TabHeading,
  Icon,
  DownloadWrapper,
} from './ViewReport.styled';
import html2pdf from 'html2pdf.js';
import {
  FacebookLogoSmall,
  InstagramIconSmall,
  NewsLogo,
  X_icon,
  YouTubeRedIcon,
  download_icon,
} from '../../Common/SvgIcon/CommonSvgIcons';
import { useSelector, useDispatch } from 'react-redux';
import Sentiments from '../ActiveTopic/Sentiments/SentimentsTab';
import Insights from '../ActiveTopic/Insights/InsightsTab';
import ReviewsTab from '../ActiveTopic/ReviewsTab/ReviewsTab';
import Overview from '../ActiveTopic/OverViewTab/OverView';
import { formatDate, formatDateFilter } from '../../utils';

import {
  fetchCreatedTopic,
  createNewTopic,
  activeTopicList,
} from '../../store/redux/slices/topicSlice';

import { getReport } from '../../store/redux/slices/sentinelHubSlice';

import { useNavigate } from 'react-router-dom';
import DownloadFile from './Download/Download';
import OverviewTabInsta from '../ActiveTopic/OverViewTab/OverviewTabInsta';
import OverviewTabFb from '../ActiveTopic/OverViewTab/OverviewTabFb';
import CustomAnalysisTab from './Download/ReportDownload/CustomAnalysisTab';
import ClusterAnalysisTab from './Download/ReportDownload/ClusterAnalysisTab';
import OverviewNews from './Download/ReportDownload/OverviewNews';
import XYZComponent from '../ActiveTopic/XYZ/XYZ';

function convertDateTime(inputDateTime) {
  let dtObject = new Date(inputDateTime);

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  let formattedDate =
    monthNames[dtObject.getMonth()] +
    ' ' +
    dtObject.getDate() +
    ' on ' +
    (dtObject.getHours() % 12 || 12) +
    ':' +
    (dtObject.getMinutes() < 10 ? '0' : '') +
    dtObject.getMinutes() +
    ' ' +
    (dtObject.getHours() >= 12 ? 'PM' : 'AM');

  return formattedDate;
}

const ViewReport = ({
  formatValue = 'dd-MM-yyyy',
  data,
  job_id,
  email_id,
  handleCancelClick,
  created_at,
  is_topic = true,
  hideDropdown,
}) => {
  const [AnalysisFilter, setAnalysisFilter] = useState('');
  const [activeTab, setActiveTab] = useState('overViewTab');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [download, setDownload] = useState(false);
  const contentDivRef = useRef(null);

  let { topicPreviewData } = useSelector((state) => state.topicBuilder) || {};
  // const topicPreviewData = data;
  const { createdTopicData } = useSelector((state) => state.topicBuilder);

  let { getAllReportData } = useSelector((state) => state.sentinelHub) || [];

  let render_string = '{}';
  let outlook_report = {};

  if (getAllReportData.find((el) => el.email_id === email_id)) {
    let tempData = getAllReportData.find((el) => el.email_id === email_id);
    render_string = tempData?.render_field_string;
    outlook_report = tempData?.report;
  }
  // else {
  //   dispatch(getReport(email_id));
  // }

  let fetchedData;

  const selectedTopic = createdTopicData.find(
    (topic) => topic.job_id === job_id
  );
  if (typeof job_id === 'number' && selectedTopic !== undefined) {
    topicPreviewData = selectedTopic;
    fetchedData = selectedTopic?.data;
  } else if (typeof email_id === 'string') {
    topicPreviewData = outlook_report;
  }
  fetchedData = topicPreviewData?.data;
  // fetchedData = getAllReportData?.length > 0  && getAllReportData[0]?.outlook_report;
  // }

  // useEffect(() => {
  //   if (typeof job_id === 'number' && selectedTopic === undefined) {
  //     dispatch(fetchCreatedTopic(job_id)).then((res) => {
  //       fetchedData = res.payload?.data?.data;
  //     });
  //   }
  // }, [job_id]);

  useEffect(() => {
    if (
      getAllReportData?.length > 0 &&
      getAllReportData?.[0]?.render_field_string
    ) {
      try {
        const parsedFilter = JSON.parse(
          getAllReportData[0].render_field_string
        );
        setAnalysisFilter(parsedFilter); // Set the parsed object to state
        // console.log(getAllReportData,'getAllReportData');
      } catch (error) {
        console.error('Failed to parse render_string:', error);
        setAnalysisFilter(null);
      }
    } else {
      console.warn('No valid render_string found');
      setAnalysisFilter(null);
    }
  }, [getAllReportData]);

  const reach_tab = getAllReportData?.[0]?.report?.data?.reach_tab || {};

  const overView_tab = getAllReportData?.[0]?.report?.data?.overview_tab || {};
  const sentiments_tab =
    getAllReportData?.[0]?.report?.data?.sentiments_tab || {};
  const insights_tab = getAllReportData?.[0]?.report?.data?.insights_tab || {};
  const clusterAnalysis_tab =
    getAllReportData?.[0]?.report?.data?.cluster_analysis_tab || {};
  const startDate = getAllReportData?.[0]?.report?.start_date || '2024/01/01';
  const endDate = getAllReportData?.[0]?.report?.end_date || '2024/01/02';
  const renderString =
    getAllReportData?.length > 0 &&
    JSON?.parse(getAllReportData[0]?.render_field_string);

  useEffect(() => {
    if (renderString) {
      const tabMap = [
        { key: 'Overviews', tab: 'overViewTab' },
        { key: 'Reach', tab: 'Reach' },
        { key: 'Sentiments', tab: 'sentimentsTab' },
        { key: 'Insights', tab: 'insightTab' },
        { key: 'Cluster_Analysis', tab: 'clusterAnalysis' },
      ];
      const firstSelected = tabMap.find((t) => renderString?.[t.key]?.value);
      if (firstSelected) {
        setActiveTab(firstSelected.tab);
      }
    }
  }, [getAllReportData]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overViewTab':
        return getAllReportData?.[0]?.report?.channel === 'news' ? (
          <OverviewNews
            formatValue={formatValue}
            overview_tab={overView_tab}
            startDate={startDate}
            endDate={endDate}
            hideDropdown={hideDropdown}
            child={renderString?.Overviews?.child}
          />
        ) : getAllReportData?.[0]?.report?.channel === 'twitter' ? (
          <Overview
            formatValue={formatValue}
            overview_tab={overView_tab}
            startDate={startDate}
            endDate={endDate}
            hideDropdown={hideDropdown}
          />
        ) : getAllReportData?.[0]?.report?.channel === 'facebook' || getAllReportData?.[0]?.report?.channel === 'youtube' ? (
          <OverviewTabFb
            formatValue={formatValue}
            overview_tab={overView_tab}
            startDate={startDate}
            endDate={endDate}
            hideDropdown={hideDropdown}
            channel={getAllReportData?.[0]?.report?.channel || ''}
          />
        ) : (
          <OverviewTabInsta
            formatValue={formatValue}
            overview_tab={overView_tab}
            startDate={startDate}
            endDate={endDate}
            hideDropdown={hideDropdown}
            child={renderString?.Overviews?.child}
          />
        );
      case 'Reach':
        return (
          <XYZComponent
            hideDropdown={hideDropdown}
            xyz={reach_tab}
            startDate={startDate}
            endDate={endDate}
            filteredStartDate={startDate}
            filteredEndDate={endDate}
            channel={getAllReportData?.[0]?.report?.channel || ''}
            child={renderString?.Reach?.child}
          />
        );
      case 'sentimentsTab':
        return (
          <Sentiments
            formatValue={formatValue}
            sentiments_tab={sentiments_tab}
            startDate={startDate}
            endDate={endDate}
            channel={getAllReportData?.[0]?.report?.channel}
            hideDropdown={hideDropdown}
            is_news={
              getAllReportData?.[0]?.report?.channel === 'news' ? true : false
            }
          />
        );
      case 'insightTab':
        return (
          <Insights
            formatValue={formatValue}
            channel={getAllReportData?.[0]?.report?.channel}
            insights_data={insights_tab}
            startDate={startDate}
            endDate={endDate}
            hideDropdown={hideDropdown}
            is_news={
              getAllReportData?.[0]?.report?.channel === 'news' ? true : false
            }
          />
        );
      case 'clusterAnalysis':
        return (
          // <ClusterAnalysisTab
          //   formatValue={formatValue}
          //   cluster_analysis={clusterAnalysis_tab}
          //   startDate={startDate}
          //   endDate={endDate}
          //   job_id={job_id}
          // />
          <ClusterAnalysisTab
            cluster_analysis={clusterAnalysis_tab}
            formatValue={formatValue}
            startDate={startDate}
            endDate={endDate}
            child={[
              {
                id: '4aa',
                name: 'Sentiments',
                type: 'checkbox',
                value: true,
                display: true,
              },
              {
                id: '4ab',
                name: 'Emotions',
                type: 'checkbox',
                value: true,
                display: true,
              },
            ]}
            // child={AnalysisFilter?.Cluster_Analysis?.child}
          />
        );
      case 'customAnalysis':
        return (
          <CustomAnalysisTab
            showCustom={false}
            AnalysisFilter={AnalysisFilter?.Custom_Analysis?.localVal}
            formatValue={formatValue}
            job_id={job_id}
            preview_uuid={getAllReportData?.[0]?.report?.preview_uuid}
          />
        );
      case 'reviewsTab':
        return (
          <ReviewsTab
            formatValue={formatValue}
            channel={getAllReportData?.[0]?.report?.channel}
            startDate={startDate}
            endDate={endDate}
            preview_uuid={getAllReportData?.[0]?.report?.preview_uuid}
            job_id={data?.job_id}
            hideDropdown={hideDropdown}
            email_id={getAllReportData?.[0]?.email_id}
            showReport={true}
          />
        );
      default:
        return null;
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleGeneratePdf = (refsArray) => {
    setDownload(true);
    const element = document.getElementById('element-to-convert');

    setAnalysisFilter(
      getAllReportData?.length > 0 &&
        JSON.parse(getAllReportData[0]?.render_field_string)
    );

    const options = {
      filename: 'myfile.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' },
    };
    setTimeout(() => {
      // Call the html2pdf function with the selected element and options
      html2pdf().from(element).set(options).save()
        .then(() => {
          setDownload(false);
          handleCancelClick();
        });
    }, 3000); // 3000 milliseconds = 3 seconds
  };
  
      const { personalDetailsData } =
          useSelector((state) => state.tenantSetting) || {};
let col=personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items :'rgba(45, 137, 85, 1)';
    
  return (
    <Wrapper>
      <HeaderWrapper>
        <Span1>
          {getAllReportData?.[0]?.report?.title ||
            getAllReportData?.[0]?.report?.chatter_title}
        </Span1>
        <Span2>{getAllReportData?.[0]?.report?.description}</Span2>
        <StyledContainer>
          <ChannelsText>Channels:</ChannelsText>
          <TwitterText>
            <Icon>
              {getAllReportData?.[0]?.report?.category == 'topic' &&
              getAllReportData?.[0]?.report?.channel == 'facebook'
                ? FacebookLogoSmall
                : getAllReportData?.[0]?.report?.channel == 'twitter'
                ? X_icon
                : getAllReportData?.[0]?.report?.channel == 'youtube'
                ? YouTubeRedIcon
                : getAllReportData?.[0]?.report?.channel == 'news'
                ? NewsLogo
                : InstagramIconSmall}
            </Icon>{' '}
            &nbsp;{' '}
            {getAllReportData?.[0]?.report?.channel
              ? getAllReportData?.[0]?.report?.channel == 'twitter'
                ? ''
                : getAllReportData?.[0]?.report?.channel?.replace(/{|}/g, '')
              : ''}
          </TwitterText>
        </StyledContainer>
        {getAllReportData?.[0]?.report?.category == 'chatter' ? (
          <b
            style={{
              color: 'rgb(45, 137, 85)',
              wordBreak: 'break-all',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >
            {getAllReportData?.[0]?.report?.hyperlink}
          </b>
        ) : (
          <QueryPara>
            <b>Query Used:&nbsp;</b>{' '}
            {getAllReportData?.[0]?.report?.keywords_string}
            <br />
          </QueryPara>
        )}
        {/* <br /> lang: en since: 2023-01-01 until: 2023-05-18 geocode: 20.5937,78.9629,2000 km */}
      </HeaderWrapper>
      <DownloadWrapper>
        <div className='created_at'>
          {(is_topic == 'topic') ? 'Topic ' : 'Chatter '}
          Created at {convertDateTime(created_at)}
        </div>

        <div className='buttonContainer'>
          <button className='button cancel' onClick={handleCancelClick}>
            Cancel
          </button>

          <button
            className='button'
            onClick={() => handleGeneratePdf(contentDivRef)}
            style={{background : col ?  col : 'rgba(45, 137, 85, 1)'}}
          >
            {download ? '...downloading' : <>Download {download_icon}</>}
          </button>
        </div>
      </DownloadWrapper>
      <TabHeading col={col}>
        {renderString?.Overviews?.value && (
          <div
            className={activeTab === 'overViewTab' ? 'activePlanTab' : ''}
            onClick={() => handleTabClick('overViewTab')}
          >
            Overviews
          </div>
        )}
        {renderString?.Reach?.value && (
          <div
            className={activeTab === 'Reach' ? 'activePlanTab' : ''}
            onClick={() => handleTabClick('Reach')}
          >
            Reach
          </div>
        )}
        {renderString?.Sentiments?.value && (
          <div
            className={activeTab === 'sentimentsTab' ? 'activePlanTab' : ''}
            onClick={() => handleTabClick('sentimentsTab')}
          >
            Sentiments
          </div>
        )}
        {renderString?.Insights?.value && (
          <div
            className={activeTab === 'insightTab' ? 'activePlanTab' : ''}
            onClick={() => handleTabClick('insightTab')}
          >
            Insights
          </div>
        )}
        {renderString?.Cluster_Analysis?.value && (
          <div
            className={activeTab === 'clusterAnalysis' ? 'activePlanTab' : ''}
            onClick={() => handleTabClick('clusterAnalysis')}
          >
            PerceptMap
          </div>
        )}
      </TabHeading>
      {renderTabContent()}

      <div style={{ display: 'none' }}>
        <div ref={contentDivRef} id='element-to-convert'>
          <DownloadFile
            AnalysisFilter={AnalysisFilter}
            email_id={data?.email_id + ''}
            created_at={data.creation_time}
            is_topic={data?.category}
            data={data}
            formatValue={formatValue}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default ViewReport;